import { format } from 'date-fns';
import { FILE_DATE_FORMAT, FILE_DATE_TIME_FORMAT } from '../constants';

export const formatDateFormToDb = (fieldValue: string): string =>
	format(new Date(String(fieldValue)), FILE_DATE_FORMAT);

export const formatDateTimeFormToDb = (fieldValue: string): string =>
	format(new Date(String(fieldValue)), FILE_DATE_TIME_FORMAT);

export const formatDateToString = (date: Date): string => format(date, FILE_DATE_TIME_FORMAT);
